// @refresh reload
import { StartClient, mount } from "@solidjs/start/client";
import "solid-devtools";

mount(() => <StartClient />, document.getElementById("app")!);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js", { scope: "/" }).then((registration) => {
    registration.update();
  });
}
